<template>
  <div>
    <section class="p-toppage__cassette">
      <div class="p-toppage__cassette__wrap">
        <div
          class="p-toppage__cassette__title sp_tabTitle"
          :class="{ 'is-active': currentId === 0 }"
          @click="onChangeSearch(0)"
        >
          LifeService
        </div>
        <div class="spacer"></div>
        <div
          class="p-toppage__cassette__title sp_tabTitle"
          :class="{ 'is-active': currentId === 1 }"
          @click="onChangeSearch(1)"
        >
          Goods
        </div>
      </div>
    </section>
    <section class="p-toppage__search">
      <div class="p-toppage__search__wrap">
        <div class="p-toppage__search__main">
          <div class="p-toppage__search__main__nav c-card">
            <!-- lifeService item filter start -->
            <template v-if="currentId === 0">
              <div class="c-card__content">
                <!-- lifeService item filter start -->
                <div class="p-toppage__search__main__input c-card__inner">
                  <p class="p-toppage__search__main__caution">
                    <span v-if="form.lifeIsActive === 1">
                      カテゴリ・ポイント・キーワードのいずれかをご入力ください
                    </span>
                  </p>
                  <div class="p-toppage__search__main__row p-toppage__search__main__block">
                    <div
                      v-if="form.lifeIsActive === 1"
                      class="p-toppage__search__main__areaSelector"
                    >
                      <div class="c-select">
                        <select
                          v-model="form.catLrgClassCd"
                          class="c-select__control"
                          :disabled="!largeCategoryList"
                          @change="onChangeLargeCat($event)"
                        >
                          <option selected value="" class="default">
                            大カテゴリ
                          </option>
                          <option
                            v-for="(large, i) in largeCategoryList"
                            :key="`large-${i}`"
                            :value="large.catClassCd"
                          >
                            {{ large.name }}
                          </option>
                        </select>
                      </div>
                      <div class="c-select">
                        <select
                          v-model="form.catMidClassCd"
                          class="c-select__control"
                          :disabled="
                            form.catLrgClassCd === '' || !middleCategoryList
                          "
                          @change="onChangeMidCat($event)"
                        >
                          <option selected value="" class="default">
                            中カテゴリ
                          </option>
                          <option
                            v-for="(middle, i) in middleCategoryList"
                            :key="`middle-${i}`"
                            :value="middle.catClassCd"
                          >
                            {{ middle.name }}
                          </option>
                        </select>
                      </div>
                      <div class="c-select">
                        <select
                          v-model="form.catSmlClassCd"
                          class="c-select__control"
                          :disabled="
                            form.catMidClassCd === '' || !smallCategoryList
                          "
                        >
                          <option selected value="" class="default">
                            小カテゴリ
                          </option>
                          <option
                            v-for="(small, i) in smallCategoryList"
                            :key="`small-${i}`"
                            :value="small.catClassCd"
                          >
                            {{ small.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <!-- 未使用
                    <div
                      v-if="form.lifeIsActive === 2"
                      class="p-toppage__search__main__areaSelector"
                    >
                      <div class="c-select">
                        <select
                          v-model="form.areaMidClassCd"
                          class="c-select__control"
                          :disabled="areaMidClasses.length === 0"
                          @change="onChangeMidArea($event)"
                        >
                          <option selected value="" class="default">
                            大エリア
                          </option>
                          <option
                            v-for="(mid, i) in areaMidClasses"
                            :key="`mid-${i}`"
                            :value="mid.areaMidClassCd"
                          >
                            {{ mid.areaMidClassNm }}
                          </option>
                        </select>
                      </div>
                      <div class="c-select">
                        <select
                          v-model="form.areaSmlClassCd"
                          class="c-select__control"
                          :disabled="
                            form.areaMidClassCd === '' ||
                              areaSmlClasses.length === 0
                          "
                          @change="onChangeSmlArea($event)"
                        >
                          <option selected value="" class="default">
                            中エリア
                          </option>
                          <option
                            v-for="(sml, i) in areaSmlClasses"
                            :key="`sml-${i}`"
                            :value="sml.areaSmlClassCd"
                          >
                            {{ sml.areaSmlClassNm }}
                          </option>
                        </select>
                      </div>
                      <div class="c-select">
                        <select
                          v-model="form.areaDtlClassCd"
                          class="c-select__control"
                          :disabled="
                            form.areaMidClassCd === '' ||
                              areaDtlClasses.length === 0
                          "
                        >
                          <option selected value="" class="default">
                            小エリア
                          </option>
                          <option
                            v-for="(small, i) in areaDtlClasses"
                            :key="`small-${i}`"
                            :value="small.areaDtlClassCd"
                          >
                            {{ small.areaDtlClassNm }}
                          </option>
                        </select>
                      </div>
                    </div>
                    -->
                  </div>
                  <!-- 未使用
                  <div
                    v-if="form.lifeIsActive === 2"
                    class="p-toppage__search__main__row"
                  >
                    <div class="p-toppage__search__main__genreSelect">
                      <div class="c-select c-select--genre">
                        <select
                          class="c-select__control"
                          :disabled="!categoryList"
                          @change="lifeGenreChanged"
                        >
                          <option selected value="" class="default">
                            ジャンル
                          </option>
                          <option
                            v-for="cat in categoryList"
                            :key="`cat-${cat.name}`"
                            :value="
                              cat.catClassCd + ',' + cat.name + ',' + cat.level
                            "
                          >
                            {{ cat.name }}
                          </option>
                        </select>
                      </div>
                      <div class="p-toppage__search__main__genreTagList">
                        <div
                          v-for="(item, index) in lifeGenreTags"
                          :key="index"
                          class="p-toppage__search__main__genreTags"
                        >
                          <span>
                            <span>
                              {{ item.name }}
                            </span>
                            <button @click="deleteLifeGenreTags(index)">
                              ×
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  -->
                  <div
                    v-if="form.lifeIsActive === 1"
                    class="p-toppage__search__main__price p-toppage__search__main__param"
                  >
                    <div class="p-toppage__search__main__param__label">ポイント</div>
                    <div class="p-toppage__search__main__input-wrapper">
                      <div class="c-input">
                        <input
                          v-model="form.priceFrom"
                          type="text"
                          inputmode="numeric"
                          maxlength="10"
                          :class="{
                            'c-input__background': true,
                            'c-input__background--error': formErrorPriceFrom
                          }"
                          @input="toNumFormatPriceFrom"
                        />
                      </div>
                      <span class="p-toppage__search__main__unit" data-translate-skip>{{ pointName }}</span>
                    </div>

                    <span class="p-toppage__search__main__unit">〜</span>

                    <div class="p-toppage__search__main__input-wrapper">
                      <div class="c-input">
                        <input
                          v-model="form.priceTo"
                          type="text"
                          inputmode="numeric"
                          maxlength="10"
                          :class="{
                            'c-input__background': true,
                            'c-input__background--error': formErrorPriceTo
                          }"
                          @input="toNumFormatPriceTo"
                        />
                      </div>
                      <span class="p-toppage__search__main__unit" data-translate-skip>{{ pointName }}</span>
                    </div>
                  </div>
                  <div class="p-toppage__search__main__row">
                    <div class="p-toppage__search__main__keyword">
                      <KeywordSearch
                        :placeholder="
                          '施設名・サービス名・メニューNoなどを入力'
                        "
                        :background="true"
                        :error="formError != ''"
                        @input="input"
                        @on-search="onSearch(currentId)"
                      />
                    </div>
                    <div
                      v-if="formError"
                      class="p-toppage__search__main__input--error"
                    >
                      <span class="p-toppage__search__main__error-icon">
                        <IconAlert name="alert" />
                      </span>
                      <span class="p-toppage__search__main__error-message">
                        {{ formError }}
                      </span>
                    </div>
                  </div>
                  <div 
                    v-if="form.lifeIsActive === 1"
                    class="p-toppage__search__main__row"
                  >
                    <div class="p-toppage__search__main__keyword">
                      <div class="p-toppage__search__main__checkbox-wrap">
                        <!-- 現在のポイント内で探す -->
                        <AppCheckbox
                          label="現在のポイント内で探す"
                          :isChecked="form.chkCurrentPoint"
                          class="p-toppage__search__main__checkbox"
                          @clicked="toggleChkCurrentPoint"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="currentId === 1">
              <ShopBeneOnlineShop :ic-points="getICPoints()"/>
            </template>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import uniqBy from "lodash/uniqBy";
import filter from "lodash/filter";
import KeywordSearch from "@/general/components/pages/KeywordSearch.vue";
import {
  getLargeCategories,
  getCodesArea,
  getLargeCodesArea
} from "@/general/store/api";
import IconAlert from "@/common/components/icons/IconAlert.vue";
import ShopBeneOnlineShop from "@/general/components/shop/BeneOnlineShop.vue";
import { getUserProfileSummary } from "@/general/store/api";
import LocalStorage from "@/general/utils/storage";
import AppCheckbox from "@/common/components/atoms/AppCheckbox.vue";
import commons from "@/common/store/modules/commons";
import { POINT_MAX } from "@/general/config/constants";

/** @typedef {import("@/general/store/models").Categories} Categories */

export default {
  components: {
    KeywordSearch,
    IconAlert,
    ShopBeneOnlineShop,
    AppCheckbox
  },
  props: {
    currentId: {
      type: Number,
      default: 0
    },
    switchTab: {
      type: Function
    }
  },
  data() {
    return {
      /** @type {{ catClassCd: string; name: string; level: number }[]} */
      lifeGenreTags: [],

      /** @type {Categories[]} */
      categories: [],

      /** @type {{ areaLrgClassCd: string; areaMidClassCd: string; areaMidClassNm: string; }[]} */
      areaMidClasses: [],

      /** @type {{ areaSmlClassCd: string; areaSmlClassNm: string; }[]} */
      areaSmlClasses: [],

      /** @type {{ areaDtlClassCd: string; areaDtlClassNm: string; }[]} */
      areaDtlClasses: [],

      form: {
        lifeIsActive: 1, // 1: LifeService > 暮らす・遊ぶ、2: LifeService > 食べる、3: Goods
        keyword: "",
        areaLrgClassCd: "",
        areaMidClassCd: "",
        areaSmlClassCd: "",
        areaDtlClassCd: "",
        catLrgClassCd: "",
        catMidClassCd: "",
        catSmlClassCd: "",
        /**
         * 価格帯FROM
         */
        priceFrom: "",
        /**
         * 価格帯TO
         */
        priceTo: "",
        chkCurrentPoint: false
      },
      /**
       * 入力エラー
       */
      formError: "",
      formErrorPriceFrom: false,
      formErrorPriceTo: false,
      userSummary: {}
    };
  },

  computed: {
    /** @returns {Array<Categories>} */
    largeCategoryList() {
      if (this.categories.length) {
        const listFilter = filter(
          this.categories,
          (item) =>
            item.level === 1 &&
            ((+item.catClassCd >= 101 && +item.catClassCd <= 114) ||
              (+item.catClassCd >= 116 && +item.catClassCd <= 119))
        );
        return uniqBy(listFilter, "catClassCd");
      }
      return [];
    },
    /** @returns {Array<Categories>} */
    middleCategoryList() {
      if (this.categories.length) {
        const listFilter = filter(this.categories, (item) => {
          if (
            item.level === 2 &&
            item.catLrgClassCd === this.form.catLrgClassCd
          ) {
            if (
              (item.catLrgClassCd === "011" || item.catLrgClassCd === "113") &&
              item.name !== "飲食店"
            ) {
              return item;
            }
            if (item.catLrgClassCd === "119" && item.name !== "お問合せ") {
              return item;
            }
            if (
              item.catLrgClassCd !== "119" &&
              item.catLrgClassCd !== "113" &&
              item.catLrgClassCd !== "011"
            ) {
              return item;
            }
          }
        });
        return uniqBy(listFilter, "catClassCd");
      }
      return [];
    },
    /** @returns {Array<Categories>} */
    smallCategoryList() {
      if (this.categories.length) {
        const listFilter = filter(
          this.categories,
          (item) =>
            item.level === 3 &&
            item.catLrgClassCd === this.form.catLrgClassCd &&
            item.catMidClassCd === this.form.catMidClassCd
        );
        return uniqBy(listFilter, "catClassCd");
      }
      return [];
    },
    /** @returns {Array<Categories>} */
    categoryList() {
      if (this.categories.length) {
        const listFilter = filter(this.categories, (item) => {
          if (
            !this.lifeGenreTags.find((o) => o.catClassCd === item.catClassCd)
          ) {
            if (
              item.level === 3 &&
              item.catLrgClassCd === "113" &&
              item.catMidClassCd === "201"
            ) {
              return item;
            }
          }
        });
        return uniqBy(listFilter, "catClassCd");
      }
      return [];
    },
    /**
     * ポイント名。指定がなければ"Point"
     * @return {string}
     */
    pointName() {
      return this.$store.state.commons.userInfo?.point_name || "Point";
    }
  },

  async mounted() {
    this.switchTab(this.currentId);
    this.getMidCodesArea();
    const res = await getLargeCategories();
    if (res) {
      this.categories = res.categories || [];
    }

    const localSummary = LocalStorage.getItem("userPointsDetails");
    if (localSummary) {
      try {
        this.userSummary = JSON.parse(localSummary);
      } catch (e) {
        console.warn("LocalStorageのパースに失敗しました", e);
      }
    } else {
      // 非同期関数の結果を await で取得
      try {
        const summary = await getUserProfileSummary();
        this.userSummary = summary;
      } catch (e) {
        console.warn("getUserProfileSummaryの取得に失敗しました", e);
        this.userSummary = {};
      }
    }
  },
  methods: {
    /**
     * 現在のポイント内で探すがクリックされたらチェック状態を切り替える
     */
    toggleChkCurrentPoint() {
      this.form.chkCurrentPoint = !this.form.chkCurrentPoint;
    },
    async getMidCodesArea() {
      const res = await getLargeCodesArea();
      if (res) {
        this.areaMidClasses = res || [];
      }
    },
    async getSmlCodesArea(index) {
      const data = this.areaMidClasses[index - 1];
      const res = await getCodesArea({
        areaLrgClassCd: data.areaLrgClassCd,
        areaMidClassCd: data.areaMidClassCd
      });
      if (res) {
        this.form.areaLrgClassCd = data.areaLrgClassCd;
        this.form.areaMidClassCd = data.areaMidClassCd;
        this.areaSmlClasses =
          res?.areaLrgClasses?.[0]?.areaMidClasses?.[0]?.areaSmlClasses || [];
      }
    },
    async getDtlCodesArea(index) {
      const data = this.areaSmlClasses[index - 1];
      const res = await getCodesArea({
        areaLrgClassCd: this.form.areaLrgClassCd,
        areaMidClassCd: this.form.areaMidClassCd,
        areaSmlClassCd: data.areaSmlClassCd
      });
      if (res) {
        this.areaDtlClasses =
          res?.areaLrgClasses?.[0]?.areaMidClasses?.[0]?.areaSmlClasses?.[0]
            ?.areaDtlClasses || [];
      }
    },
    /* 未使用
    lifeNavChange(num) {
      this.form.lifeIsActive = num;
      this.form.catLrgClassCd = "";
      this.form.catMidClassCd = "";
      this.form.catSmlClassCd = "";
      this.form.areaLrgClassCd = "";
      this.form.areaMidClassCd = "";
      this.form.areaSmlClassCd = "";
      this.form.areaDtlClassCd = "";
      this.formError = "";
      this.lifeGenreTags = [];
    },
    */
    lifeGenreChanged(e) {
      if (!e.target.value) {
        return;
      }

      const category = e.target.value.split(",");
      this.lifeGenreTags.push({
        catClassCd: category[0],
        name: category[1],
        level: category[2]
      });
    },
    deleteLifeGenreTags(index) {
      this.$delete(this.lifeGenreTags, index);
    },
    input(value) {
      this.form.keyword = value;
    },
    /**
     * 正数値かのチェック
     */
    isNumber(num) {
      if (num) {
        const number = Number(num);
        if (number >= 0) {
          if (!Number.isInteger(number)) {
            return false;
          }
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    /**
     * 入力チェック
     */
    validate() {
      if (this.form.lifeIsActive === 1) {
        this.formErrorPriceFrom = false;
        this.formErrorPriceTo = false;
        // 必須チェック
        if (
          this.form.keyword === "" &&
          this.form.catLrgClassCd === "" &&
          this.form.catMidClassCd === "" &&
          this.form.catSmlClassCd === "" &&
          this.form.priceFrom === "" &&
          this.form.priceTo === ""
        ) {
          return "カテゴリ・ポイント・キーワードのいずれかをご入力ください";
        }

        let hasNumError = false;
        if (!this.isNumber(this.form.priceFrom)) {
          hasNumError = true;
          this.formErrorPriceFrom = true;
        }
        if (!this.isNumber(this.form.priceTo)) {
          hasNumError = true;
          this.formErrorPriceTo = true;
        }
        if (hasNumError) {
          return "ポイントは正数値で入力してください";
        }

        // From/Toの整合性チェック
        if (
          this.form.priceFrom !== "" &&
          this.form.priceTo !== "" &&
          Number(this.form.priceFrom) > Number(this.form.priceTo)
        ) {
          this.formErrorPriceFrom = true;
          this.formErrorPriceTo = true;
          return "ポイントの範囲指定が不正です";
        }

        return "";
      }
    },
    getICPoints() {
      // ポイント取得
      let userPoint = 0;
      if (!this.userSummary) {
        this.userSummary = LocalStorage.getItem("userPointsDetails")
          ? JSON.parse(LocalStorage.getItem("userPointsDetails"))
          : "";
      }

      if (this.userSummary) {
        if (commons?.userInfo?.groupBudgetMode) {
          if (this.userSummary.group_budget_point > 0) {
            userPoint = this.userSummary.group_budget_point;
          }
        } else {
          if (this.userSummary.grant_points > 0) {
            userPoint = this.userSummary.grant_points;
          }
          if (this.userSummary.thanks_points > 0) {
            userPoint += this.userSummary.thanks_points;
          }
          if (this.userSummary.kenko_points > 0) {
            userPoint += this.userSummary.kenko_points;
          }
        }
      }
      return userPoint;
    },
    onSearch(currentId) {
      if (this.form.lifeIsActive === 1) {
        // 現在のポイントで探すにチェックした場合、priceFromを空に、priceToに使用可能ポイントをセットする
        if (this.form.chkCurrentPoint) {
          this.form.priceFrom = "";
          this.form.priceTo = String(this.floorIC(this.getICPoints()));
        }
      }

      this.formError = this.validate();
      if (this.formError) {
        return;
      }
      
      const params = new URLSearchParams(this.getQueryString());
      const url =
        process.env.VUE_APP_LIFE_DOMAIN + "/product/list-life?" + params;
      window.open(url, "_self");
    },
    /** 10の位を切り上げした数字を返す */
    ceilIC(amount) {
      // 10のくらいできりあげ
      if (amount == null || amount == 0) {
        return amount;
      }
      return Math.ceil(amount / 100) * 100;
    },
    /** 10の位を切り捨てた数字を返す */
    floorIC(amount) {
      // 10のくらいで切り捨てた切り捨て
      if (amount == null || amount == 0) {
        return amount;
      }
      return Math.floor(amount / 100) * 100;
    },
    convZenkakuNum(e) {
      if (e) {
        const hankakuNum = e.replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
        });
        const numStr = hankakuNum.replace(/[^0-9]/gi, "");
        if (numStr != "") {
          return String(Number(numStr));
        }
      }
      return "";
    },
    toNumFormatPriceFrom(e) {
      const numStr = this.convZenkakuNum(e.target.value);
      if (numStr != "") {
        this.form.priceFrom = numStr;
      } else {
        this.form.priceFrom = "";
      }
    },
    toNumFormatPriceTo(e) {
      const numStr = this.convZenkakuNum(e.target.value);
      if (numStr != "") {
        this.form.priceTo = numStr;
      } else {
        this.form.priceTo = "";
      }
    },
    getQueryString() {
      const query = {};
      switch (this.form.lifeIsActive) {
        case 1:
          query.type = 1;
          if (this.form.catLrgClassCd) {
            query.catLrgClassCd = this.form.catLrgClassCd;
          }
          if (this.form.catMidClassCd) {
            query.catMidClassCd = this.form.catMidClassCd;
          }
          if (this.form.catSmlClassCd) {
            query.catSmlClassCd = this.form.catSmlClassCd;
          }
          if (this.form.priceFrom) {
            if (Number(this.form.priceFrom) > POINT_MAX) {
              this.form.priceFrom = String(POINT_MAX);
            } else {
              this.form.priceFrom = String(this.ceilIC(this.form.priceFrom));
            }
            query.priceFrom = this.form.priceFrom;
          }
          if (this.form.priceTo) {
            if (Number(this.form.priceTo) > POINT_MAX) {
              this.form.priceTo = String(POINT_MAX);
            } else {
              this.form.priceTo = String(this.ceilIC(this.form.priceTo));
            }
            query.priceTo = this.form.priceTo;
          }
          if (this.form.chkCurrentPoint) {
            query.chkCurrentPoint = this.form.chkCurrentPoint;
          }
          break;
        /* 未使用
        case 2:
          query.type = 2;
          if (this.form.areaMidClassCd) {
            query.areaMidClassCd = this.form.areaMidClassCd;
          }
          if (this.form.areaSmlClassCd) {
            query.areaSmlClassCd = this.form.areaSmlClassCd;
          }
          if (this.form.areaDtlClassCd) {
            query.areaDtlClassCd = this.form.areaDtlClassCd;
          }
          if (this.lifeGenreTags.length) {
            const tags = this.lifeGenreTags.map((x) => x.catClassCd);
            query.lifeGenreTags = tags;
          }
          break;
        default:
          break;
        */
      }
      if (this.form.keyword) {
        query.keyword = this.form.keyword;
      }
      return query;
    },
    onChangeMidArea(event) {
      if (event.target.value === "") {
        this.form.areaMidClassCd = "";
        this.form.areaSmlClassCd = "";
        this.form.areaDtlClassCd = "";
        this.areaSmlClasses = [];
        this.areaDtlClasses = [];
      } else if (event.target.value !== "") {
        this.form.areaMidClassCd = event.target.value;
        this.form.areaSmlClassCd = "";
        this.form.areaDtlClassCd = "";
        this.areaSmlClasses = [];
        this.areaDtlClasses = [];
        this.getSmlCodesArea(event.target.selectedIndex);
      }
    },
    onChangeSmlArea(event) {
      if (event.target.value === "") {
        this.form.areaSmlClassCd = "";
        this.form.areaDtlClassCd = "";
        this.areaDtlClasses = [];
      } else if (event.target.value !== "") {
        this.form.areaSmlClassCd = event.target.value;
        this.form.areaDtlClassCd = "";
        this.areaDtlClasses = [];
        this.getDtlCodesArea(event.target.selectedIndex);
      }
    },
    onChangeLargeCat(event) {
      if (event.target.value === "") {
        this.form.catLrgClassCd = "";
        this.form.catMidClassCd = "";
        this.form.catSmlClassCd = "";
      } else if (event.target.value !== "") {
        this.form.catLrgClassCd = event.target.value;
        this.form.catMidClassCd = "";
        this.form.catSmlClassCd = "";
      }
    },
    onChangeMidCat(event) {
      if (event.target.value === "") {
        this.form.catMidClassCd = "";
        this.form.catSmlClassCd = "";
      } else if (event.target.value !== "") {
        this.form.catMidClassCd = event.target.value;
        this.form.catSmlClassCd = "";
      }
    },
    onChangeSearch(clickedId) {
      this.switchTab(clickedId);
      this.form.keyword = "";
      this.form.catLrgClassCd = "";
      this.form.catMidClassCd = "";
      this.form.catSmlClassCd = "";
      this.form.priceFrom = "";
      this.form.priceTo = "";
      this.form.chkCurrentPoint = false
      this.formError = "";
      this.formErrorPriceFrom = false;
      this.formErrorPriceTo = false;
      if (clickedId === 0) {
        window.history.replaceState(null, "", "?selected=life");
        this.form.lifeIsActive = 1;
      }
      if (clickedId === 1) {
        window.history.replaceState(null, "", "?selected=goods");
        // 未使用
        // this.form.lifeIsActive = 2;
      }
      // this.middleCategoryList();
    }
  }
};
</script>
<style scoped lang="scss">
section {
  display: block;
}

.p-toppage__cassette {
  margin: 2rem 0 1rem;

  .p-toppage__cassette__wrap {
    display: flex;
    padding-bottom: 0.5rem;
    width: 90%;
    margin: 0 auto;

    .p-toppage__cassette__title {
      width: calc(91.6% / 2);
      padding-bottom: 0.5rem;
      cursor: pointer;
      font-size: 16px;
      font-weight: bold;
      text-align: center;

      img {
        width: 0.75rem;
        height: auto;
        display: inline-block;
        margin-left: 0.5rem;
      }
    }

    .p-toppage__cassette__title.is-active {
      color: #da291c;
      border-bottom: 3px solid #da291c;
    }

    .spacer {
      width: 0.2%;
      background-color: #dcdee0;
      margin: 0 2%;
      height: 1.5rem;
      border-radius: 4px;
    }
  }
}

.p-toppage__search {
  margin-bottom: 3rem;

  .p-toppage__search__wrap {
    .p-toppage__search__main {
      margin-bottom: 2rem;

      .p-toppage__search__main__nav {
        overflow: visible;

        .c-card__inner {
          padding: 2rem;

          .p-toppage__search__main__row {
            .p-toppage__search__main__areaSelector {
              display: flex;
              flex-wrap: wrap;

              .c-select {
                position: relative;
                width: calc(100% / 3 - 0.5rem);
                margin-right: 0.5rem;

                .c-select__control {
                  cursor: pointer;
                  font-size: 1rem;
                  line-height: 1.25;
                  background: #fff;
                  border: 1px solid #cacccf;
                  border-radius: 4px;
                  padding: 0.375rem 0.5rem;
                  width: 100%;
                  height: 2.5rem;
                }

                select {
                  appearance: none;
                }
              }

              .c-select:after {
                content: "";
                position: absolute;
                right: 10px;
                top: 15px;
                width: 10px;
                height: 10px;
                border-top: 2px solid #ccc;
                border-left: 2px solid #ccc;
                transform: translateY(-50%) rotate(-135deg);
                font-size: 20px;
                pointer-events: none;
              }
            }

            .p-toppage__search__main__point {
              display: flex;
              align-items: center;

              .p-toppage__search__main__point__content {
                display: flex;
                align-items: center;
                .p-toppage__search__main__point__content__input {
                  display: flex;
                  margin: 10px;
                  align-items: center;

                  input {
                    border: 1px solid gray;
                    border-radius: 3px;
                    padding: 10px 15px;
                  }
                  p {
                    margin-left: 15px;
                  }
                }

                .p-toppage__search__main__point__content__space {
                  font-size: 20px;
                  font-weight: 700;
                  padding: 0px 30px;
                }
              }
            }
            .p-toppage__search__main__point:last-child {
              display: block;
              .p-toppage__search__main__point__content__input--error {
                color: #cc0621;
              }
            }
          }

          .p-toppage__search__main__row + .p-toppage__search__main__row {
            margin-top: 1rem;
          }
        }
      }

      .c-card {
        background: #fff;
        box-shadow: 0 1px 0.5rem rgb(31 32 33 / 8%);
        border-radius: 0.5rem;
        line-height: 1.8;
      }

      .c-card > :last-child {
        margin-bottom: 0;
      }

      &__param {
        display: flex;
        margin-bottom: 1rem;

        &__label {
          height: 40px;
          line-height: 40px;
          vertical-align: middle;
          width: 120px;
        }

        .c-input {
          display: inline-block;
        }
      }

      &__unit {
        height: 40px;
        line-height: 40px;
        margin-left: 0.25rem;
        margin-right: 1rem;
        @include mq() {
          line-height: normal;
          font-size: 0.875rem;
        }
      }

      &__caution {
        line-height: 1.5;
        padding: 0 0 1rem;

        @include sp {
          font-size: 0.875rem;
        }
      }

      &__error-icon {
        vertical-align: middle;
      }

      &__error-message {
        @include sp {
          font-size: 0.875rem;
        }
      }

      &__checkbox-wrap {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin-bottom: 0.5rem;
        margin-top: 0.5rem;
      }

      &__checkbox {
        flex-shrink: 0;
        font-size: 14px;
        width: auto;
      }

      &__block {
        margin-bottom: 1rem;
      }

      @include mq() {
        &__param {
          display: block;
        }

        &__price {
          .p-toppage__search__main__input-wrapper {
            margin-bottom: 0.5rem;
            width: 100%;
            white-space: nowrap;
          }
          .c-input {
            display: inline-block;
            width: calc(100% - 80px);
          }
        }
      }
    }
  }
}

$Red: #da291c;
$CoolBlack: #1f2021;
$CoolGray3: #cacccf;
$CoolGray6: #f4f5f6;
$ErrorBg: #fae6e9;

$radiusSizeSm: 0.25rem;

.c-input {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  > * {
    height: 100%;
  }
  input[type="text"]:focus {
    outline: none;
  }

  input[type="text"] {
    padding: 0.5rem;
    width: 100%;
    border: 1px solid $CoolGray3;
    border-radius: $radiusSizeSm;
    color: $CoolBlack;
    line-height: 1.8;
    overflow: hidden;
    background-color: #fff;
    &::placeholder {
      color: $CoolGray3;
    }
  }

  &__background {
    background: $CoolGray6 !important;
    &:focus {
      background-color: #fff7f7 !important;
      border: 1px solid $Red !important;
    }
    &--error {
      background: $ErrorBg !important;
    }
  }
}

@media only screen and (max-width: 640px) {
  .p-toppage__cassette__wrap {
    gap: 10px;
  }
  .sp_tabTitle {
    font-size: 13px;
    white-space: nowrap;
    &.is-active,
    &.is-active > a {
      color: #dd0000;
    }
  }
}
</style>
